import { render, staticRenderFns } from "./TestUsersCombo.vue?vue&type=template&id=64b8a23e&scoped=true"
import script from "./TestUsersCombo.vue?vue&type=script&lang=js"
export * from "./TestUsersCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b8a23e",
  null
  
)

export default component.exports